import { createStore } from "vuex";
import axios from "axios";
import { API_URL } from "@/config/config";

const savedUser = localStorage.getItem("user"); // ← Recupera usuario guardado
const savedTheme = localStorage.getItem("theme") || "light"; // ← Recupera tema guardado

// Aplica el tema guardado al cargar
if (savedTheme === "dark") {
  document.documentElement.classList.add("dark");
} else {
  document.documentElement.classList.remove("dark");
}

export default createStore({
  state: {
    user: savedUser ? JSON.parse(savedUser) : null,
    isAuthenticated: !!savedUser,
    totalPendientes: 0,
    theme: savedTheme,
  },
  mutations: {
    setUser(state, userData) {
      state.user = userData;
      state.isAuthenticated = true;
    },
    logout(state) {
      state.user = null;
      state.isAuthenticated = false;
    },
    setTotalPendientes(state, total) {
      state.totalPendientes = total;
    },
    setTheme(state, theme) {
      state.theme = theme;
      localStorage.setItem("theme", theme);
      if (theme === "dark") {
        document.documentElement.classList.add("dark");
      } else {
        document.documentElement.classList.remove("dark");
      }
    },
  },
  actions: {
    login({ commit }, userData) {
      commit("setUser", userData);
      localStorage.setItem("user", JSON.stringify(userData)); // ← Guarda en localStorage
    },
    logout({ commit }) {
      commit("logout");
      localStorage.removeItem("user"); // ← Borra de localStorage
    },
    async fetchTotalPendientes({ commit }) {
      const res = await axios.get(`${API_URL}/totalEspera`);
      commit("setTotalPendientes", res.data.total);
    },
    toggleTheme({ commit, state }) {
      const newTheme = state.theme === "light" ? "dark" : "light";
      commit("setTheme", newTheme);
    },
  },
  getters: {
    getUser: (state) => state.user,
    isAuthenticated: (state) => state.isAuthenticated,
    totalPendientes: (state) => state.totalPendientes,
    theme: (state) => state.theme,
    isDarkMode: (state) => state.theme === "dark",
  },
});
